import * as S from './styles'

type TitleCardProps = {
  title: string
  children?: React.ReactNode
}

const TitleCard = ({ title, children }: TitleCardProps) => (
  <S.HeaderTitleContainer>
    <S.HeaderTitle>{title}</S.HeaderTitle>
    {children}
  </S.HeaderTitleContainer>
)

export default TitleCard
